import { z } from "zod";
export const PropertyDefinitionSchema = z.object({
    displayName: z.string().optional(),
    description: z.string(),
    exampleValues: z.array(z.union([
        z.string(),
        z.number(),
        z.boolean(),
        z.undefined()
    ])),
    availableSinceVersion: z.string().default("3.0.0")
});
